(function () {
  'use strict';

  angular
    .module('component.addtowishlist', [])

    .component('buttonAddToWishlist', {
      bindings: {
        isProductButton: '<?',
        id: '<idProduct',
        isPrimary: '<',
        url: '@productUrl',
        titleAdd: '@',
        titleRemove: '@',
        tooltipAdd: '@',
        tooltipYet: '@',
        tooltipChoice: '@?',
        message: '@'
      },
      templateUrl: 'component.addtowishlist.tpl',
      /* @ngInject */
      controller: ["$scope", "$rootScope", "$location", "$window", "whishListService", "AppService", "HttpService", "ModalService", "toastr", function ($scope, $rootScope, $location, $window, whishListService, AppService, HttpService, ModalService, toastr) {
        var ctrl = this;

        ctrl.$onInit = function () {
          update();
        };

        ctrl.wishListConnect = function (url) {
          ctrl.isLogged = true;
          ctrl.addToWishList(url);
        };

        ctrl.addToWishList = function (redirect) {
          if (!ctrl.isPrimary) {
            if (!ctrl.isProductButton) openQuickView();
            return;
          }

          var url = ctrl.isInWishList ? '/WishList/Remove' : '/Product/AddWishList';
          var message = ctrl.isInWishList ? decodeURI(ctrl.titleRemove) : decodeURI(ctrl.titleAdd);

          ctrl.tooltip = '';
          ctrl.loading = true;
          if (ctrl.isLogged) {
            HttpService.post({
              url: url,
              data: ctrl.id
            })
            .then(function (response) {
              if (response.status === 'OK') {
                ctrl.isInWishList = !ctrl.isInWishList;
                updateTooltip(ctrl.isInWishList);
                whishListService.set(response.results.Products);
                update(true);
                if (!ctrl.manageWishList) {
                  $rootScope.$broadcast('userUpdate');
                }
                toastr.success('', message, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              if (redirect) {
                $window.location.assign(redirect).reload();
              }
              ctrl.loading = false;
            })
            .catch(function (error) {
              console.error(error);
            });
          } else {
            ModalService.show(
              '/Template/Authentication/ModalAuthentication',
              {
                message: ctrl.message,
                url: $location.path(),
                action: function (redirectUrl) {
                  ctrl.wishListConnect(redirectUrl);
                }
              },
              null,
              'loginModalCtrl',
              null,
              null,
              null,
              null,
              function () {
                ctrl.loading = false;
              }
            );
          }
        };

        $scope.$on('login', function () {
          ctrl.isLogged = true;
        });
        $scope.$on('logout', function () {
          ctrl.isLogged = false;
        });
        $scope.$on('wishListUpdate', function () {
          whishListService.get()
            .then(function (list) {
              var result = false;
              _.each(list, function (line) {
                if (line.Product.IDProduct === ctrl.id) {
                  result = true;
                  return false;
                }
              });
              ctrl.isInWishList = result;
              updateTooltip(result);
            });
        });

        // Functions
        function openQuickView() {
          ModalService.show(
            '/Template/Modal/ModalQuickView',
            {
              url: ctrl.url,
              windowClass: 'modal-quick-view'
            },
            'lg',
            'modalQuickViewCtrl',
            null,
            ctrl.device,
            {
              modalTitle: ctrl.tooltipChoice
            }
          );
        }

        function update(refresh) {
          refresh = refresh || false;
          AppService.getParams(refresh)
            .then(function (params) {
              ctrl.isLogged = params.IsLogged ? 1 : 0;
              ctrl.manageWishList = params.Account.IsManagementWishlistTracking;

              whishListService.load();
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function updateTooltip(value) {
          ctrl.tooltip = value ? ctrl.tooltipYet : ctrl.tooltipAdd;
          ctrl.tooltip = !ctrl.isPrimary && ctrl.isProductButton ? ctrl.tooltipChoice : ctrl.tooltip;
        }

      }]
    })

    /* @ngInject */
    .factory('whishListService', ["$rootScope", "HttpService", function ($rootScope, HttpService) {
      var promise;

      this.load = function () {
        if (!promise) {
          promise = HttpService.get({
            url: '/WishList/Products',
            cache: false
          }).then(function (response) {
            $rootScope.$broadcast('wishListUpdate');
            return response.results.Products;
          }).catch(function (error) {
            console.error(error);
          });
        } else if (promise.$$state.value) {
          $rootScope.$broadcast('wishListUpdate');
        }
      };

      this.get = function () {
        return promise;
      };

      this.set = function (data) {
        promise.$$state.value = data;
        $rootScope.$broadcast('wishListUpdate');
      };

      this.reset = function () {
        promise = null;
      };

      return {
        load: this.load,
        get: this.get,
        set: this.set,
        reset: this.reset
      };

    }]);

})();
